<main class="auth-wrap">
    <div class="content">
        <img src="assets/images/logo-main.svg" class="img-fluid d-block m-auto" alt="logo">
        <div class="form-wrap" *ngIf="!resendFormSubmitted">
            <h2>Please click resend button</h2>
            <form [formGroup]="confirmEmailForm">
                <div class="form-group" [ngClass]="{'error': confirmEmailForm.controls.email.touched && !confirmEmailForm.controls.email.valid}">
                    <input type="email" class="form-control" formControlName="email" id="nameInput" autocomplete="off" placeholder="Email">
                    <!-- <label for="nameInput" *ngIf="confirmEmailForm.get('email').value == ''">Enter email here<sup>*</sup></label>
                    <form-validation-message [control]="confirmEmailForm.controls.email"></form-validation-message> -->
                </div>
                <button type="submit" class="btn btn-green" (click)="resend()">Resend</button>
            </form>
        </div>

        <div class="form-wrap" *ngIf="resendFormSubmitted">
            <h2>Email confirmed. <br/>Please login</h2>
            <button type="submit" class="btn btn-green" routerLink="/login">Login</button>
        </div>
    </div>
</main>
